import { render } from "./VenueGroupMenu.vue?vue&type=template&id=f7000756&scoped=true"
import script from "./VenueGroupMenu.vue?vue&type=script&lang=js"
export * from "./VenueGroupMenu.vue?vue&type=script&lang=js"

import "../_css/sidebarmenu.scss?vue&type=style&index=0&id=f7000756&lang=scss&scoped=true&external"
import "./VenueGroupMenu.vue?vue&type=style&index=1&id=f7000756&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7000756"]])

export default __exports__